@use "variables" as *;

.spineImageContainer {
  position: absolute;
  right: $spacing-m;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  height: fit-content;
}

.spineDraggableDivHorizontal {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.spineDraggableDivVertical {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.spineDragHandleHorizontal {
  display: flex;
  align-items: center;
  overflow: hidden;
  border-style: solid none solid solid;
  border-width: 2px 0 2px 2px;
  border-color: black;
  border-radius: 6px 0 0 6px;
}

.spineDragHandleVertical {
  display: flex;
  align-items: center;
  overflow: hidden;
  border-style: solid solid none solid;
  border-width: 2px 2px 0 2px;
  border-color: black;
  border-radius: 6px 6px 0 0;
}

.spineImageHorizontal {
  height: 70px;
  max-width: 100%;
}

.spineImageVertical {
  width: 70px;
  max-height: 100%;
}
